import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import { createContext } from 'react';
import { UserClaimsData, UserData } from '@ypp-portal/models/user/userData';
import { AdminClaimsData, DepartmentChairClaimsData } from '@ypp-portal/models/user/staffData';
import { InstructorData } from '@data/user/instructorData';

export type IdTokenWithClaims<T extends UserClaimsData = UserClaimsData> =
  firebase.auth.IdTokenResult & { claims: T };

interface AuthData<T extends UserData = UserData, TClaims extends UserClaimsData = UserClaimsData> {
  user: firebase.User;
  idToken: IdTokenWithClaims<TClaims>;
  userDoc: firebase.firestore.DocumentSnapshot<T>;
}

// AuthContext providers should be able to guarantee that
// user nor userDoc will be undefined, but they will be
// undefined here for initilization purposes
export const GenericAuthContext = createContext({} as AuthData);

export const InstructorAuthContext = createContext({} as AuthData<InstructorData>);

export const AdminAuthContext = createContext({} as AuthData<UserData, AdminClaimsData>);

export const DepartmentChairAuthContext = createContext(
  {} as AuthData<UserData, DepartmentChairClaimsData>
);
